import { useEffect, useState } from "react";
import { getScreenSize, onScreenSizeChange, ScreenSize } from '../support/utils';


export function useScreenSize() {
  const [size, setSize] = useState<ScreenSize>(() =>
    typeof window === "undefined" ? { width: 0, height: 0 } : getScreenSize()
  );

  useEffect(() => {
    if (typeof window === "undefined") return;
    return onScreenSizeChange(setSize);
  }, []);

  return size;
}